/* eslint-disable angular/window-service */
angular.module('tgaAdmin').config([
  '$logProvider', 'envServiceProvider',
  function ($logProvider, envServiceProvider) {
    if (envServiceProvider.get() === 'production') {
      $logProvider.debugEnabled(false);

      // Override native logging
      if (!window.console) {
        window.console = {};
      }

      const methods = ['log', 'debug', 'warn', 'info'];
      for (let i = 0; i < methods.length; i++) {
        // eslint-disable-next-line no-console
        console[methods[i]] = () => {};
      }
    } else {
      $logProvider.debugEnabled(true);
    }
  },
]);
